/**
 * Request Status Codes - API codes used in backend communication
 */
export enum RequestStatusCode {
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  SUBMITTED_ONHOLD = 'SUBMITTED_ONHOLD',
  WITHDRAWN = 'WITHDRAWN',
  RTSUBMITTED = 'RTSUBMITTED',
  RETRACTED = 'RETRACTED',
  RESUBMITTED = 'RESUBMITTED',
  RETURNED = 'RETURNED',
}

/**
 * Maps status codes to display labels
 */
export const REQUEST_STATUS_CODE_TO_LABEL: Record<RequestStatusCode, string> = {
  [RequestStatusCode.SUBMITTED]: 'Submitted',
  [RequestStatusCode.APPROVED]: 'Approved',
  [RequestStatusCode.DENIED]: 'Denied',
  [RequestStatusCode.SUBMITTED_ONHOLD]: 'On Hold',
  [RequestStatusCode.WITHDRAWN]: 'Withdrawn',
  [RequestStatusCode.RTSUBMITTED]: 'Retraction Submitted',
  [RequestStatusCode.RETRACTED]: 'Retracted',
  [RequestStatusCode.RESUBMITTED]: 'Resubmitted',
  [RequestStatusCode.RETURNED]: 'Returned',
}

/**
 * Maps display labels to status codes (reverse lookup)
 */
export const REQUEST_STATUS_LABEL_TO_CODE: Record<string, RequestStatusCode> = Object.entries(
  REQUEST_STATUS_CODE_TO_LABEL
).reduce(
  (acc, [code, label]) => {
    acc[label] = code as RequestStatusCode
    return acc
  },
  {} as Record<string, RequestStatusCode>
)

/**
 * All valid status codes as array (for API filters)
 */
export const ALL_STATUS_CODES: RequestStatusCode[] = Object.values(RequestStatusCode)

// Legacy export for backward compatibility
export const REQUEST_STATUS = {
  APPROVED: 'Approved',
  PARTIALLY_APPROVED: 'Partially Approved',
  DENIED: 'Denied',
  PARTIALLY_DENIED: 'Partially Denied',
  WITHDRAWN: 'Withdrawn',
  ON_HOLD: 'On Hold',
  SUBMITTED: 'Submitted',
  RETRACTED: 'Retracted',
  RETRACTION: 'Retraction',
  PARTIAL_RETRACTION: 'Partial Retraction',
  RETURNED: 'Returned',
  DRAFT_REQUEST: 'Draft Request',
} as const

export type RequestStatusKey = keyof typeof REQUEST_STATUS
export type RequestStatus = (typeof REQUEST_STATUS)[RequestStatusKey]

// Legacy alias for backward compatibility
export const CALENDAR_STATUS_LABEL_TO_CODE = REQUEST_STATUS_LABEL_TO_CODE

export default REQUEST_STATUS
